const isPermissionEnabled = (
  userRole,
  categoryId,
  permissionId,
  accountType
) => {
  if (accountType === "superadmin") {
    return true
  }

  if (userRole && userRole.permissions) {
    const roleWithRoleCategory = userRole.permissions.find(
      role => role.id === categoryId
    )
    if (roleWithRoleCategory) {
      const permission = roleWithRoleCategory.permissions.find(
        permission => permission.id === permissionId
      )
      return permission && permission.isEnabled
    }
  }
  return false
}


export const getSubPermissions = (
  userRole,
  categoryId,
  permissionId,
  accountType
) => {
  if (userRole && userRole.permissions) {
    const roleWithRoleCategory = userRole.permissions.find(
      role => role.id === categoryId
    );
    if (roleWithRoleCategory) {
      const permission = roleWithRoleCategory.permissions.find(
        permission => permission.id === permissionId
      );

      if (permission && permission.subPermissions) {
        const subPermissionsData = permission.subPermissions.reduce((acc, subPermission) => {
          acc[subPermission.id] = { ...subPermission, isEnabled: accountType === 'superadmin' ? true : subPermission.isEnabled };
          return acc;
        }, {});
        return subPermissionsData;
      } else {
        return permission && permission.isEnabled;
      }
    }
  }
  return false;
};

export default isPermissionEnabled; 